<template>
  <div id="detial" v-loading="pageLoading">
    <!-- <div class="mainTitle">
      <span style="color:#A2AABC;font-size: 18px;">试题答疑&nbsp;/</span>
      题型管理
    </div>-->
    <el-card class="box-card" style="margin-bottom:20px;font-size:14px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/questionQuery' }">试题答疑</el-breadcrumb-item>
        <el-breadcrumb-item>题型管理</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    <div class="main">
      <div class="contant-left">
        <div class="item">
          <div class="title">{{questionDetial.courseName||""}} | {{question.questionPropertyName}}</div>
          <div class="ptitle" v-if="questionDetial.ptitle" v-html="questionDetial.ptitle"></div>
          <div v-if="questionDetial.optionList">
            <div class="question-title" v-html="questionDetial.title"></div>
            <div
              v-for="(item,index) in questionDetial.optionList "
              :key="index"
              class="question-contant"
            >{{item.options}}、<span v-html="item.name"></span></div>
          </div>
          <div v-else>
            <div class="question-title" v-html="questionDetial.title"></div>
          </div>
        </div>
        <!-- <div style="height:20px;background-color: rgb(246, 249, 250);width:calc(100% + 20px);margin-left:0px;"></div> -->
        <div class="item" style="margin-top:20px;">
          <div class="title">试题答案</div>
          <div class="question-title" v-html="questionDetial.answer"></div>
          <div class="title">试题解析</div>
          <div class="question-title" style="font-size:12px;" v-html="questionDetial.analysis"></div>
          <div class="title">视频/音频</div>
          <div v-if="questionDetial.videoPath">
            <video
              style="max-height: 400px;width: auto;"
              controls
              preload="auto"
              oncontextmenu="return false"
              :src="questionDetial.videoPath"
              v-if="questionDetial.videoPath?questionDetial.videoPath.indexOf('mp4')>-1:false"
            ></video>
            <audio
              style="margin-top:20px;"
              :src="questionDetial.videoPath"
              controls="controls"
              v-if="questionDetial.videoPath?questionDetial.videoPath.indexOf('mp3')>-1:false"
            ></audio>
          </div>
        </div>
      </div>

      <div class="contant-right" v-if="showRight">
        <div v-if="question.state==1||question.state==-1">
          <div class="title">
            <span style="float:left">提问</span>
            <span style="float:right">{{question.createTime}}[{{question.studentMobile||"无"}}]</span>
          </div>
          <div class="question-title" style="font-size:12px;" v-html="question.query"></div>
          <div class="title">回复问题</div>
          <div style="margin-bottom:10px;">{{question.reply}}</div>
          <div class="title">回复人</div>
          <div>{{question.replyUser}}</div>
          <div style="margin-top:20px;margin-right:20px;">
            <div
              style="line-height:32px;margin-bottom:10px;"
              class="re"
            >本课程待答疑：{{question.handleQuestionQueryCountByCourse}}</div>
            <el-button @click="updateQuestion">编辑试题</el-button>
            <!-- <el-row :gutter="20">
              <el-col style="margin-bottom: 10px;" :sm="24" :md="12" :lg="8">
                <span
                  style="line-height:32px;"
                  class="re"
                >本课程待答疑：{{question.handleQuestionQueryCountByCourse}}</span>
              </el-col>
              <el-col style="margin-bottom: 10px;" :sm="24" :md="12" :lg="6">
                <el-button @click="updateQuestion">编辑试题</el-button>
              </el-col>
            </el-row>-->
          </div>
        </div>
        <div v-else>
          <div class="title">
            <span style="float:left">提问</span>
            <span style="float:right">{{question.createTime}}[{{question.studentMobile||"无"}}]</span>
          </div>
          <div class="question-title" style="font-size:12px;" v-html="question.query"></div>
          <div class="title">回复问题</div>
          <div style="margin-bottom:20px;">
            <el-input type="textarea" rows="6" v-model="answer.reply" placeholder="请输入"></el-input>
          </div>
          <div class="title">回复人</div>
          <div>
            <el-input placeholder="请输入" v-model="answer.replyUser"></el-input>
          </div>
          <div style="margin-top:20px;">
            <div
              style="line-height:32px;margin-bottom:10px;"
              class="re"
            >本课程待答疑：{{question.handleQuestionQueryCountByCourse}}</div>

            <el-button @click="replyQuestionQuery" type="primary">回复问题</el-button>

            <el-button plain @click="cancelQuestionQuery">取消问题</el-button>
            <el-button @click="updateQuestion">编辑试题</el-button>
            <!-- <el-row :gutter="20">
              <el-col style="margin-bottom: 10px;" :sm="24" :md="12" :lg="8"></el-col>
              <el-col style="margin-bottom: 10px;" :sm="24" :md="12" :lg="6"></el-col>
              <el-col style="margin-bottom: 10px;" :sm="24" :md="12" :lg="6"></el-col>
              <el-col style="margin-bottom: 10px;" :sm="24" :md="12" :lg="6"></el-col>
            </el-row>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      question: {},
      showRight: false,
      pageLoading: false,
      questionDetial: {},
      answer: {
        reply: "",
        replyUser: ""
      },
      questionId: ""
    };
  },
  created() {},
  watch: {
    questionId() {
      this.question = {};
      this.showRight = false;
      this.questionDetial = {};
      this.answer = {
        reply: "",
        replyUser: ""
      };
      this.questionQueryInfo();
    }
  },
  mounted() {
    this.questionId = this.$route.query.id;
    this.questionQueryInfo();
  },
  methods: {
    //编辑试题
    updateQuestion() {
      if (this.questionDetial.big == 1) {
        this.$router.push({
          path: "/addCpQuestion",
          query: {
            upId: this.questionDetial.id,
            idsss: this.questionId
          }
        });
      } else {
        this.$router.push({
          path: "/addQuestion",
          query: {
            upId: this.questionDetial.id,
            upPid: this.questionDetial.pid,
            idsss: this.questionId
          }
        });
      }
    },
    //取消回复
    cancelQuestionQuery() {
      this.$confirm("您确定要进行取消操作吗？", "系统消息", {
        type: "warning"
      }).then(() => {
        this.api.questionQuery
          .cancelQuestionQuery({ id: this.questionId })
          .then(result => {
            if (result.success) {
              this.$message.success(result.message);
              // this.questionQueryInfo();
              this.$confirm("是否处理本课程的下一个答疑？", "系统消息", {
                type: "warning"
              })
                .then(() => {
                  if (this.question.nextQuestionQueryId) {
                    this.questionId = this.question.nextQuestionQueryId;
                    this.questionQueryInfo();
                  } else {
                    this.$message.success("本课程答疑已全部处理");
                  }
                })
                .catch(() => {
                  this.questionQueryInfo();
                });
            } else {
              this.$message.error(result.message);
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    //回复问题
    replyQuestionQuery() {
      this.answer.id = this.questionId;
      if (!this.answer.reply) {
        return this.$message.error("请输入回复内容");
      }
      if (!this.answer.replyUser) {
        return this.$message.error("请输入回复人");
      }
      this.api.questionQuery
        .replyQuestionQuery(this.answer)
        .then(result => {
          if (result.success) {
            this.$message.success(result.message);
            // this.questionQueryInfo();

            this.$confirm("是否处理本课程的下一个答疑？", "系统消息", {
              type: "warning"
            })
              .then(() => {
                if (this.question.nextQuestionQueryId) {
                  this.questionId = this.question.nextQuestionQueryId;
                  this.questionQueryInfo();
                } else {
                  this.$message.success("本课程答疑已全部处理");
                }
              })
              .catch(() => {
                this.questionQueryInfo();
              });
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    questionQueryInfo() {
      this.pageLoading = true;
      this.api.questionQuery
        .questionQueryInfo({ id: this.questionId })
        .then(result => {
          this.pageLoading = false;
          if (result.success) {
            this.question = result.data;
            result.data.question.title = result.data.question.title
              .replace(
                result.data.question.title ? /&(?!#?\w+;)/g : /&/g,
                "&amp;"
              )
              .replace(/&lt;/g, "<")
              .replace(/&gt;/g, ">")
              .replace(/&quot;/g, '"')
              .replace(/&#39;/g, "'");
            this.questionDetial = result.data.question;
          } else {
            this.question = {};
            this.questionDetial = {};
            this.$message.error(result.message);
          }
          this.showRight = true;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less">
#detial {
  width: 100%;
  // height: 100%;
  .main {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    .contant-left {
      width: calc(70% - 40px);
      .item {
        .ptitle {
          font-size: 16px;
          color: #455a64;
          text-align: left;
          margin-bottom: 14px;
          line-height: 28px;
          background: #f2f5f8;
        }
        border-radius: 4px;
        background: #fff;
        padding: 10px;

        .title {
          font-weight: 400;
          font-style: normal;
          color: #a2aabc;
          line-height: 13px;
          font-size: 12px;
          margin-bottom: 20px;
        }
        .question-title {
          font-size: 16px;
          color: #455a64;
          text-align: left;
          margin-bottom: 14px;
          line-height: 28px;
        }
        .question-contant {
          font-size: 16px;
          color: #455a64;
          text-align: left;
          line-height: 28px;
          p{
            display: inline;
          }
        }
      }
    }
    .contant-right {
      background: #fff;
      border-radius: 4px;
      padding: 10px;
      width: 30%;
      .title {
        font-weight: 400;
        font-style: normal;
        color: #a2aabc;
        line-height: 13px;
        font-size: 12px;
        height: 20px;
        white-space: nowrap;
      }
      .question-title {
        font-size: 16px;
        color: #455a64;
        text-align: left;
        margin-bottom: 14px;
        line-height: 28px;
      }
    }
  }
  .re {
    color: rgb(255, 117, 107);
    font-size: 14px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/questionQuery/queryDetial.vue